import React, { Suspense } from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { Responsive } from '@lyearn/molecules';
import { PageError } from '@/components/Error';
import Loader from '@/components/Loader';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import DoesNotExist from '@/modules/corporate/components/DoesNotExist';

import InViewModal from './components/InViewModal';
import useLearnerProfile from './hooks/useLearnerProfile';
import LearnerProfileDesktop from './index.desktop';
import LearnerProfileMobile from './index.mobile';
import { LearnerProfileProps } from './types';

function LearnerProfile(props: LearnerProfileProps) {
  const { learnerId } = props;
  const { isMobile } = useScreen();
  const { id: currentUserId } = useUserContext();
  const {
    fetching,
    error,
    learner,
    onAction,
    inViewModal,
    isPublishingAssignment,
    isUpdatingLearnerProfile,
  } = useLearnerProfile({ learnerId, isMGSAProfile: false });

  if (fetching) {
    return <Loader />;
  }

  if (error) {
    return <PageError error={error} />;
  }

  if (!learner) {
    return <DoesNotExist />;
  }

  return (
    <>
      <Responsive>
        <Responsive.Default>
          <LearnerProfileDesktop
            key={learner.status}
            isCurrentUser={learner.id === currentUserId}
            learner={learner}
            onAction={onAction}
          />
        </Responsive.Default>
        <Responsive.Mobile>
          <LearnerProfileMobile
            key={learner.status}
            isCurrentUser={learner.id === currentUserId}
            learner={learner}
            onAction={onAction}
          />
        </Responsive.Mobile>
      </Responsive>
      <Suspense fallback={null}>
        <InViewModal
          inViewModal={inViewModal}
          isPublishingAssignment={isPublishingAssignment}
          isUpdatingLearnerProfile={isUpdatingLearnerProfile}
          learner={learner}
          onAction={onAction}
        />
      </Suspense>
    </>
  );
}

export default LearnerProfile;
